import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Reply {
  _id: string;
  userId: string;
  comment: string;
  isLiked:boolean;
  isDisliked:boolean;
  likesCount:number;
  // ... other fields as needed
}
interface Comment {
  _id: string;
  text: string;
  createdAt: string;
  replies: Reply[];
  isLiked:boolean;
  isDisliked:boolean;
  likesCount:number;
  // ... other fields as needed
}

interface CommentsState {
  comments: Comment[];
}

const initialState: CommentsState = {
  comments: []
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    setComments: (state, action: PayloadAction<Comment[]>) => {
      state.comments = action.payload;
    },
    addComment: (state, action: PayloadAction<Comment>) => {
      state.comments.unshift(action.payload);
    },
    addReplyToComment: (
      state,
      action: PayloadAction<{ commentId: string; reply: Reply }>
    ) => {
      const { commentId, reply } = action.payload;
      const comment = state.comments.find((c) => c._id === commentId);
      if (comment) {
        comment.replies.push(reply);
      }
    },
    toggleCommentLike: (state, action: PayloadAction<string>) => {
      const comment = state.comments.find(c => c._id === action.payload);
      if (comment) {
        comment.isLiked = !comment.isLiked;
        if (comment.isLiked) {
          comment.likesCount += 1;
          if (comment.isDisliked) {
            comment.isDisliked = false;
          }
        } else {
          comment.likesCount -= 1;
        }
      }
    },
    toggleCommentDislike: (state, action: PayloadAction<string>) => {
      const comment = state.comments.find(c => c._id === action.payload);
      if (comment) {
        comment.isDisliked = !comment.isDisliked;
        if (comment.isDisliked) {
          if (comment.isLiked) {
            comment.isLiked = false;
            comment.likesCount -= 1;
          }
        }
      }
    },
    toggleReplyLike: (state, action: PayloadAction<{ commentId: string; replyId: string }>) => {
      const { commentId, replyId } = action.payload;
      const comment = state.comments.find(c => c._id === commentId);
      const reply = comment?.replies.find(r => r._id === replyId);
      if (reply) {
        reply.isLiked = !reply.isLiked;
        if (reply.isLiked) {
          reply.likesCount += 1;
          if (reply.isDisliked) {
            reply.isDisliked = false;
          }
        } else {
          reply.likesCount -= 1;
        }
      }
    },
    toggleReplyDislike: (state, action: PayloadAction<{ commentId: string; replyId: string }>) => {
      const { commentId, replyId } = action.payload;
      const comment = state.comments.find(c => c._id === commentId);
      const reply = comment?.replies.find(r => r._id === replyId);
      if (reply) {
        reply.isDisliked = !reply.isDisliked;
        if (reply.isDisliked) {
          if (reply.isLiked) {
            reply.isLiked = false;
            reply.likesCount -= 1;
          }
        }
      }
    },    
  }
});

export const {
  setComments,
  addComment,
  addReplyToComment,
  toggleCommentLike,
  toggleCommentDislike,
  toggleReplyLike,
  toggleReplyDislike,
} = commentsSlice.actions;

export default commentsSlice.reducer;
